let banners = {
  home: {
    HOME_TOPO: {
      redirectLink: "www.google.com",
      desktop: "../images/api/banners/homeTopo/placeholder_desktop.png",
      mobile: "../images/api/banners/homeTopo/placeholder_mobile.png",
    },
    HOME_SECUNDARIO: {
      redirectLink: "www.google.com",
      desktop: "../images/api/banners/homeSecundario/placeholder_desktop.png",
      mobile: "../images/api/banners/homeSecundario/placeholder_mobile.png",
    }
  },
  sobre: {
    SOBRE_TOPO: {
      redirectLink: "www.google.com",
      desktop: "../images/api/banners/sobreTopo/placeholder_desktop.png",
      mobile: "../images/api/banners/sobreTopo/placeholder_mobile.png",
    },
    SOBRE_SECUNDARIO: {
      redirectLink: "www.google.com",
      desktop: "../images/api/banners/sobreSecundario/placeholder_desktop.png",
      mobile: "../images/api/banners/sobreSecundario/placeholder_mobile.png",
    }
  }
};

export default banners;